import { Component, OnInit, ViewEncapsulation, AfterContentChecked, OnDestroy } from '@angular/core';
import { UserRoles } from 'src/app/enums/userRoles.enum';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';
import { Location } from '@angular/common';
import { Console } from 'console';
import { Sidebar2Service } from './sidebar2.service';
import { EmployeeModel } from 'src/app/Models/EmpCareerUser.model';
import { TimeSheetservice } from 'src/app/views/time-stamp/time-stamp.service';
import { UserDetailsDTO } from 'src/app/views/time-stamp/DataModel';
import { UserService } from 'src/app/services/user.service';

declare var $: any;

@Component({
  selector: 'app-sidebar2',
  templateUrl: './sidebar2.component.html',
  styleUrls: ['./sidebar2.component.css']
})
export class Sidebar2Component implements OnInit, AfterContentChecked, OnDestroy {
  public isSuperAdmin: boolean;
  adminRole = 1;
  canViewSideMenu = true;
  public userItemAccessible: boolean;
  public homeRouteFlag = true;
  public loading = false;
  public role: string;
  public isShow = false;
  salesClass: string = "sales";
  isPanelExpanded = false;
  isKMSPanelExpanded = false;
  isCareerPanelExpanded = false;
  isRequestsPanelExpanded = false;
  hideEmployee = false;
  applyChildClass: boolean = false;
  showdashboardbutton: boolean= false;
  showemployeeimpersonation: boolean= false;
  
  public hideMenu = {
    dashboard: false,
    competency: false,
    home: false,
    employee: false,
    executive: false,
    techstack: false,
    salaryRangeCalcualtor: false,
    skillRepository: false,
    uploadData: false,
    employeData: false,
    templates: false,
    proposals: false,
    mockups: false,
    employeemenu: false,
    sales: false,
    salesdashboard: false,
    projectcontent: false,
    pendingapprovals: false,
    users: false,
    career: false,
    other: false,
    dmdPortal: false,
    ppmPortal: false,
    compliance: false,
    portal: false,
    audits: false,
    timeSheet: false,
    pstimesheet: false,
    poc:true,
    employeeWithoutCompetency: false,
  };
  employeeDetails: EmployeeModel;
  isEmpCareerManager: boolean = false;
  accessForKMS: boolean = false;
  accessForAddPrograms:boolean=false;
  timeSheetManagerNamesAll: UserDetailsDTO[] = [];
  timesheetview: boolean = false;
  // pstimesheetview: boolean = false;
  empCareerUserDetailsSubcription: any;
  

  constructor(
    private auth: AuthServiceService,
    private router: Router,
    private dialog: MatDialog,
    private location: Location,
    private toggleSidebar: Sidebar2Service,
    private timesheetservice: TimeSheetservice,
    public userService: UserService
  ) { }



  ngOnInit() {
    //this.timesheetLogin();
   
    this.empCareerUserDetailsSubcription = this.userService.empCareerUserDetails.subscribe(data => {
      if (data) {
        if (typeof data === 'string') {
          this.employeeDetails = JSON.parse(data);
        } else if (typeof data === 'object') {
          this.employeeDetails = data;
        }
        this.isEmpCareerManager = this.employeeDetails?.isManager;
        if(this.isEmpCareerManager)
        {
        this.showemployeeimpersonation=true;
        }
        if ( this.employeeDetails.gradeId == 1 && this.employeeDetails.role == "Intern") {   
          this.hideMenu.poc = false;
        }
        if (this. role && !this.role.includes(GsdRoles.PMORole) && this.employeeDetails.gradeId != 1 && this.employeeDetails.role != "Intern") {   
          this.hideMenu.timeSheet = true;
          this.timesheetview = true;
          // this.pstimesheetview = true;
        }
      }
    })
    this.role = this.auth.getRole();
    if (this.location.path) {
      if (this.location.path() === '/login' || this.location.path() === '/Home' || this.location.path() === '') {
        this.canViewSideMenu = false;
      }
      else {
        this.canViewSideMenu = true;
      }
    }
    if (this.router.url === '/landingpage') {
      this.homeRouteFlag = false;
    }
    if (
      this.role.includes(UserRoles.Admin) ||
      this.role.includes(UserRoles.SuperAdmin) ||
      this.role.includes(UserRoles.ContentManager) ||
      this.role.includes(UserRoles.Viewer)
    ) {
      this.accessForKMS = true;
    }
    if (this.role.includes(GsdRoles.Admin)) {
      this.adminRole = 0;
      this.hideMenu.dashboard = true;
      this.hideMenu.uploadData = true;
      this.hideMenu.skillRepository = true;
      this.hideMenu.templates = true;
      this.hideMenu.competency = true;
      this.hideMenu.portal = true;
      this.hideMenu.ppmPortal = true;
      this.hideMenu.dmdPortal = true;
      this.hideMenu.employeData = true;
      this.hideMenu.proposals = true;
      this.hideMenu.mockups = true;
      this.hideMenu.employeemenu = true;
      this.hideMenu.sales = true;
      this.hideMenu.career = true;
      this.hideMenu.executive = false;
      this.hideMenu.techstack = true;
      this.hideMenu.salaryRangeCalcualtor = false;
      this.hideMenu.other = true;
      this.showemployeeimpersonation=true;
      // this.hideMenu.poc = true;
    }
    if (this.role.includes(GsdRoles.SuperAdmin)) {
      this.adminRole = 0;
      this.accessForAddPrograms=true;
      this.hideMenu.dashboard = true;
      this.hideMenu.uploadData = true;
      this.hideMenu.skillRepository = true;
      this.hideMenu.employeeWithoutCompetency = true;
      this.hideMenu.templates = true;
      this.hideMenu.competency = true;
      this.hideMenu.portal = true;
      this.hideMenu.ppmPortal = true;
      this.hideMenu.dmdPortal = true;
      this.hideMenu.employeData = true;
      this.hideMenu.proposals = true;
      this.hideMenu.mockups = true;
      this.hideMenu.employeemenu = true;
      this.hideMenu.sales = true;
      this.hideMenu.career = true;
      this.hideMenu.executive = true;
      this.hideMenu.techstack = true;
      this.hideMenu.salaryRangeCalcualtor = true;
      this.hideMenu.other = true;
      this.hideMenu.compliance = true;
      this.hideMenu.audits = true;
      // this.hideMenu.poc = true;
      this.timesheetview = true;
      this.showemployeeimpersonation=true;
      // this.pstimesheetview = true;
    } else {
      this.adminRole = 1;
    }
    if (this.role.includes(GsdRoles.SkillUser)) {
      // this.userRole = true;
      this.hideMenu.dashboard = true;
      this.hideMenu.uploadData = false;
      this.hideMenu.skillRepository = false;
      this.hideMenu.employeeWithoutCompetency = false;
      this.hideMenu.templates = false;
      this.hideMenu.competency = false;
      this.hideMenu.portal = false;
      this.hideMenu.employeData = false;
      this.hideMenu.proposals = false;
      this.hideMenu.mockups = false;
      this.hideMenu.employeemenu = false;
      this.hideMenu.sales = false;
      this.hideMenu.home = true;
      this.hideMenu.career = true;
      this.hideMenu.employee = false;
      this.hideMenu.executive = false;
      this.hideMenu.techstack = false;
      this.isPanelExpanded = true;
      this.isCareerPanelExpanded = true;
      this.isRequestsPanelExpanded = false;
      this.hideEmployee = true;
      this.salesClass = "salesuser";
      this.applyChildClass = true;
      this.hideMenu.salaryRangeCalcualtor = false;
      this.hideMenu.other = false;
      this.hideMenu.compliance = false;
      this.hideMenu.poc = true;
    }
    if (this.role.includes(GsdRoles.CompetencyLeader)) {
      this.adminRole = 0;
      this.hideMenu.dashboard = true;
      this.hideMenu.skillRepository = true;
      this.hideMenu.employeeWithoutCompetency = true;
      this.hideMenu.templates = true;
      this.hideMenu.competency = false;
      this.hideMenu.portal = false;
      this.hideMenu.uploadData = false;
      this.hideMenu.employeData = false;
      this.hideMenu.mockups = false;
      this.hideMenu.employeemenu = false;
      this.hideMenu.sales = false;
      this.hideMenu.proposals = false;
      this.hideMenu.executive = false;
      this.hideMenu.techstack = false;
      this.hideMenu.salaryRangeCalcualtor = true;
      // this.hideMenu.poc = true;
      this.timesheetview = true;
      this.showemployeeimpersonation=true;
      // this.pstimesheetview = true;
    }
    if (this.role.includes(GsdRoles.SubCompetencyLeader)) {
      this.hideMenu.dashboard = true;
      this.hideMenu.skillRepository = true;
      this.hideMenu.employeeWithoutCompetency = true;
      this.hideMenu.templates = true;
      this.hideMenu.competency = false;
      this.hideMenu.portal = false;
      this.hideMenu.uploadData = false;
      this.hideMenu.employeData = false;
      this.hideMenu.mockups = false;
      this.hideMenu.employeemenu = false;
      this.hideMenu.sales = false;
      this.hideMenu.proposals = false;
      this.hideMenu.executive = false;
      this.hideMenu.techstack = false;
      this.hideMenu.salaryRangeCalcualtor = true;
      // this.hideMenu.poc = true;
      this.timesheetview = true;
      this.showemployeeimpersonation=true;
      // this.pstimesheetview = true;
    }
    if (this.role.includes(GsdRoles.Leadership)) {
      this.adminRole = 0;
      this.hideMenu.dashboard = true;
      this.hideMenu.skillRepository = true;
      this.hideMenu.employeeWithoutCompetency = false;
      this.hideMenu.templates = true;
      this.hideMenu.competency = false;
      this.hideMenu.portal = true;
      this.hideMenu.uploadData = false;
      this.hideMenu.employeData = false;
      this.hideMenu.mockups = false;
      this.hideMenu.employeemenu = false;
      this.hideMenu.sales = true;
      this.hideMenu.proposals = true;
      this.hideMenu.executive = false;
      this.hideMenu.techstack = false;
      this.hideMenu.salaryRangeCalcualtor = false;
      this.hideMenu.other = true;
      this.hideMenu.ppmPortal = true;
      this.hideMenu.dmdPortal = true;
      // this.hideMenu.poc = true;
      this.timesheetview = true;
      this.showemployeeimpersonation=true;
      // this.pstimesheetview = true;
    }
    if (this.role.includes(UserRoles.Viewer)) {
      this.hideMenu.sales = true;
      this.hideMenu.salesdashboard = false;
      this.hideMenu.projectcontent = true;
      this.hideMenu.pendingapprovals = true;
      this.hideMenu.users = true;
      // this.hideMenu.poc = true;
    }
    if (this.role.includes(UserRoles.ContentManager)) {
      this.hideMenu.sales = true;
      this.hideMenu.salesdashboard = false;
      this.hideMenu.projectcontent = false;
      this.hideMenu.pendingapprovals = true;
      this.hideMenu.users = true;
      // this.hideMenu.poc = true;
    }
    if (
      this.role.includes(UserRoles.Admin) ||
      this.role.includes(UserRoles.SuperAdmin)
    ) {
      this.hideMenu.sales = true;
      this.hideMenu.salesdashboard = false;
      this.hideMenu.projectcontent = false;
      this.hideMenu.pendingapprovals = false;
      this.hideMenu.users = false;
    }

    // if (this.role.includes(GsdRoles.SkillUser)) {
    //   this.userRole = true;
    // }

    if (!this.role.includes(GsdRoles.SuperAdmin)) {
      this.canViewSideMenu = false;
    }
 
   
  // const empId = parseInt(localStorage.getItem('Id'));
  // const isSuperAdmin = localStorage.getItem('isSuperAdmin') === 'true';

  // if (isSuperAdmin) {
  //   this.timesheetview = true;
  //   this.pstimesheetview = true;
  // } else {
  //   this.timesheetservice.getAllManagersName().subscribe(managers => {
  //     this.timeSheetManagerNamesAll = managers.data;
  //     let managerData = this.timeSheetManagerNamesAll.find(x => x.employeeId == empId);
  //     if (managerData) {
  //       this.timesheetview = true;
  //       this.pstimesheetview = true;
  //     } else {
  //       this.timesheetview = true;
  //       this.pstimesheetview = true;
  //     }
  //   });
  // }
}

  ngOnDestroy(): void {
    this.empCareerUserDetailsSubcription?.unsubscribe();
  }

  async getECPuserData() {
    const storedData = localStorage.getItem('empCareerUserDetails');
    if (storedData) {
      this.employeeDetails = JSON.parse(storedData);
    }
  }
  stopPropagation(event: MouseEvent) {
    event.stopPropagation();
  }
  ngAfterContentChecked() {
    this.isShow = this.toggleSidebar.sidebarShow;
  }
  public dismissSidebar() {
    $('#sidebaryu').removeClass('active');
    $('.overlay').removeClass('active');
    this.toggleSidebar.updateSidebarshow(false);
  }

  public gotoaccessemployeedashboard()
  {
    this.loading = true;

    this.router.navigate(['Home/Dashboard/Employee Impersonation'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }

  public HomeNavigate() {
    this.dismissSidebar();
  }
  public employeeMenu() {

    if (this.isShow === false) {
      this.isShow = !this.isShow;
    }
  }
  public homeNavigate() {
    this.router.navigate(['/Home'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }

  public rolesNavigate() {
    this.loading = true;
    this.router.navigate(['Home/Add Roles'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }
  public bulkUploadNavigate() {
    this.loading = true;
    this.router.navigate(['Home/dataupload'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }
  public templatesNavigate() {
    this.loading = true;
    this.router.navigate(['Home/Artifactory Repository'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }

  public competencyNavigate() {
    this.loading = true;
    this.router.navigate(['Home/CMF Portal'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }

  public complianceNavigate() {
    this.loading = true;
    this.router.navigate(['Home/Compliance'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }

  public caseStudiesNavigate() {
    this.loading = true;
    this.router.navigate(['Home/KMSPortal'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }
  public proposalNavigate() {
    this.loading = true;
    this.router.navigate(['Home/Proposal Repository'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }
  public approvedProjectsNavigate() {
    this.loading = true;
    this.router.navigate(['Home/KMSPortal/Project Content'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }

  public pendingProjectsNavigate() {
    this.loading = true;
    this.router.navigate(['Home/KMSPortal/Pending Approvals'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }

  public organizationsNavigate() {
    this.loading = true;
    this.router.navigate(['Home/organizationlist'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }
  public employeeDataNavigate() {
    this.loading = true;
    this.router.navigate(['Home/employeedata'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }
  public mockupsNavigate() {
    this.loading = true;
    this.router.navigate(['Home/mockups'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }
  public usersNavigate() {
    this.loading = true;
    this.router.navigate(['users/userlist'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }

  public employeeCareerPathNavigate() {
    this.loading = true;

    this.router.navigate(['Home/employee-career/employee-Career-path'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }

  public employeeCareerProgramNavigate() {
    this.loading = true;

    this.router.navigate(['Home/employee-career/employee-Career-program'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }

  public programCatalogueNavigate() {
    this.loading = true;
    this.isEmpCareerActivated() ? this.router.navigate(['Home/employee-career/employee-Career-path'])
      .then(() => {
        this.router.navigateByUrl('/Home/employee-career/employee-Career-path/program-catalogue', { state: { selectedGrade: '' } });
        this.loading = false
      })
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      }) : this.router.navigate(['Home/employee-career/'])
        .then(() => {
          this.router.navigateByUrl('/Home/employee-career/program-catalogue', { state: { selectedGrade: '' } });
          this.loading = false
        })
        .catch(err => {
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: '280px',
            data: { message: 'Cannot Open', class: 'text-danger' }
          });
        });
    this.dismissSidebar();
  }

  AddprogramsNavigate() {
    this.loading = true;
    this.router.navigate(['Home/employee-career/add-programs']).then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }

  public employeeCareerRequestNavigate() {
    this.loading = true;

    this.router.navigate(['Home/employee-career/employee-Career-request'])
      .then(nav => this.loading = false)
      .catch(err => {
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '280px',
          data: { message: 'Cannot Open', class: 'text-danger' }
        });
      });
    this.dismissSidebar();
  }

  public employeeCareerRequestsNavigate(requestType: string) {
    this.loading = true;
    if (requestType == "myrequests") {
      this.router.navigate(['Home/employee-career/employee-Career-request/my-requests'])
        .then(nav => this.loading = false)
        .catch(err => {
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: '280px',
            data: { message: 'Cannot Open', class: 'text-danger' }
          });
        });
    }
    if (requestType == "teamrequests") {
      this.router.navigate(['Home/employee-career/employee-Career-request/team-requests'])
        .then(nav => this.loading = false)
        .catch(err => {
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: '280px',
            data: { message: 'Cannot Open', class: 'text-danger' }
          });
        });
    }
    this.dismissSidebar();
  }

  hasUsersModuleAuthorization() {
    return this.auth.getRole().indexOf('CaseStudies.SuperAdmin') >= 0 || this.auth.getRole().indexOf('CaseStudies.Admin') >= 0;
  }
  hasOrganizationsModuleAuthorization() {
    return this.auth.getRole().indexOf('CaseStudies.SuperAdmin') >= 0;
  }
  isAuthorizedUser() {
    var roles = this.auth.getRole();
    if (roles.indexOf('SuperAdmin') >= 0 || roles.indexOf('Proposal.Admin') >= 0 || roles.indexOf('Template.Admin') >= 0 || roles.indexOf('Skill.Admin') >= 0) {
      return true;
    }
    else {
      return false
    }
  }

  isEmpCareerActivated(): boolean {
    if (
      this.router.url === '/Home/employee-career/employee-Career-program'
      || this.router.url === '/Home/employee-career/employee-Career-request'
      || this.router.url === '/Home/employee-career/employee-Career-request/my-requests'
      || this.router.url === '/Home/employee-career/employee-Career-request/team-requests'
      || this.router.url === '/Home/employee-career/program-catalogue'
      || this.router.url === '/Home/employee-career/add-programs') {
      return true;
    }
    else {
      return false;
    }
  }
  isEmpCareerRequestsActivated(): boolean {
    if (this.router.url === '/Home/employee-career/employee-Career-request/my-requests' || this.router.url === '/Home/employee-career/employee-Career-request/team-requests') {
      return true;
    }
    else {
      return false;
    }
  }
  isKMSActivated(): boolean {
    if (this.router.url === '/Home/KMSPortal' || this.router.url === '/Home/KMSPortal/Project Content'
      || this.router.url === 'Home/KMSPortal/Pending Approvals' || this.router.url === '/users/userlist') {
      return true;
    }
    else {
      return false;
    }
  }
  isEmpActivated(): boolean {
    if (this.router.url === '/Home/Dashboard' || this.router.url === '/Home/employee-career/employee-Career-path' || this.router.url === '/Home/employee-career/employee-Career-program'
      || this.router.url === '/Home/employee-career/employee-Career-request/my-requests' || this.router.url === '/Home/employee-career/employee-Career-request/team-requests' || this.router.url === '/Home/Skill%20Repository'
      || this.router.url === '/Home/employee-career/program-catalogue'
      || this.router.url === '/Home/employee-career/add-programs') {
      return true;
    }
    else {
      return false;
    }
  }
  salaryRangeNavigate() {
    let salaryCalculatorUrl = 'http://172.16.0.45:8074?id_token=' + localStorage.getItem('MsSSOToken');
    window.open(salaryCalculatorUrl, "_blank");
    this.dismissSidebar();
  }
  // async timesheetLogin() {
  //   const empId = parseInt(localStorage.getItem('Id'));
  //   const isSuperAdmin = localStorage.getItem('isSuperAdmin') === 'true';

  //   if (!isSuperAdmin) {
  //       this.timesheetview = false;
  //       this.pstimesheetview = false;
  //       return;
  //   }

  //   await this.timesheetservice.getAllManagersName().subscribe(managers => {
  //       this.timeSheetManagerNamesAll = managers.data;
  //       let managerData = this.timeSheetManagerNamesAll.find(x => x.employeeId == empId);
  //       if (managerData) {
  //           this.timesheetview = true;
  //           this.pstimesheetview = true;
  //       } else {
  //           this.timesheetview = false;
  //           this.pstimesheetview = false;
  //       }
  //   });


}
